export class EstoqueOutrasFiliais{
    filial: number;
    qtdEstoque: number;
    
    constructor(json?: any) {
        if (json) {     
            this.filial = json.filial;
            this.qtdEstoque = json.qtdEstoque; 
        }
    }
}